import React from 'react';
import PropTypes from 'prop-types';
import ScrollTop from '../../components/scroll-top';
import './styles.css';
import {convertPipeToBrTag} from "../../utils";

/**
 * AccessoryDetailPage
 */
const AccessoryDetailPage = ({
                        hideScrollTop,
                        pcHeading,
                        mbHeading,
                        header,
                        upperPageNavigation,
                        hero,
                        children,
                        lowerPageNavigation,
                        footer,
                        ctaNavi,
                        anchorNavi,
                        cookieEditor,
                      }) => {
  const getPcHeading = () => {
    if (pcHeading && pcHeading !== '') {
      return pcHeading;
    } else {
      if (mbHeading && mbHeading !== '') {
        return mbHeading;
      }
    }
    return null
  };
  const getMbHeading = () => {
    if (pcHeading && pcHeading !== '') {
      if (mbHeading && mbHeading !== '') {
        return mbHeading;
      } else {
        return pcHeading;
      }
    } else {
      if (mbHeading && mbHeading !== '') {
        return mbHeading;
      }
    }
    return null
  };
  return (
    <div className="StandardPage">
      {(header !== null) ? <header className="StandardPage__header">{header}</header>: null}
      {(upperPageNavigation !== null) ? <nav className="StandardPage__navigation">{upperPageNavigation}</nav>: null}
      <main className="StandardPage__main">
        {/*{(hero !== null) ?
          <div className="hero">{hero}</div>
          : null}*/}
        {/*{(getPcHeading() !== null && getMbHeading() !== null) ?
          <h1 className="StandardPage__heading">
                        <span className="StandardPage__heading-pc">
                            <div dangerouslySetInnerHTML={{__html: convertPipeToBrTag(getPcHeading())}}/>
                        </span>
            <span className="StandardPage__heading-mb">
                            <div dangerouslySetInnerHTML={{__html: convertPipeToBrTag(getMbHeading())}}/>
                        </span>
          </h1>
          : null}*/}
        {(children !== null) ? children: null}
      </main>
      {(lowerPageNavigation !== null) ?
        <nav className="StandardPage__bottom-navigation">{lowerPageNavigation}</nav>: null}
      {(footer !== null) ? <footer className="StandardPage__footer">{footer}</footer>: null}
      {(hideScrollTop === false) ? <ScrollTop/>: null}
      {(ctaNavi !== null) ? ctaNavi: null}
      {(anchorNavi !== null) ? anchorNavi: null}
      {(cookieEditor !== null) ? cookieEditor: null}
    </div>
  );
};
AccessoryDetailPage.propTypes = {
  hideScrollTop: PropTypes.bool,
  pageName: PropTypes.string,
  pcHeading: PropTypes.string,
  mbHeading: PropTypes.string,
  showPageTitle: PropTypes.bool,
  header: PropTypes.node,
  upperPageNavigation: PropTypes.node,
  hero: PropTypes.node,
  children: PropTypes.node,
  lowerPageNavigation: PropTypes.node,
  footer: PropTypes.node,
  ctaNavi: PropTypes.node,
  anchorNavi: PropTypes.node,
  cookieEditor: PropTypes.node,
};
AccessoryDetailPage.defaultProps = {
  hideScrollTop: null,
  pageName: null,
  pcHeading: null,
  mbHeading: null,
  showPageTitle: null,
  header: null,
  upperPageNavigation: null,
  hero: null,
  children: null,
  lowerPageNavigation: null,
  footer: null,
  ctaNavi: null,
  anchorNavi: null,
  cookieEditor: null,
};
export default AccessoryDetailPage;



// WEBPACK FOOTER //
// ./src/containers/accessory-detail-page/index.jsx